var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsPages = function SvgPbsPages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "pbs-pages_svg__pbs-pages",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.552.481H4.18a.673.673 0 0 0 0 1.344h7.7v7.7a.672.672 0 0 0 1.345 0V1.154c0-.37-.3-.672-.672-.672"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.943 4.089H1.345a.673.673 0 0 0-.672.672v7.6c0 .37.301.672.672.672h7.598c.37 0 .672-.302.672-.672v-7.6a.67.67 0 0 0-.672-.672"
  })));
};
export default SvgPbsPages;